import { END_POINT } from "config/environment";
import { AUTHKIT_STATE_KEY } from "config/authStorage";

export const refreshUserPermissions = async (token: string) => {
  try {
    const response = await fetch(`${END_POINT.BASE_URL}/user`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const freshData = await response.json();
      const freshUser = freshData.user || freshData;

      const authState = localStorage.getItem(AUTHKIT_STATE_KEY);
      if (authState && freshUser) {
        const parsedAuth = JSON.parse(authState);

        parsedAuth.user = {
          ...parsedAuth.user,
          ...freshUser,
        };

        localStorage.setItem(AUTHKIT_STATE_KEY, JSON.stringify(parsedAuth));

        window.dispatchEvent(new CustomEvent("userInfoUpdated"));

        return true;
      }
    } else {
      console.error("Failed to fetch fresh user data:", response.status);
    }

    return false;
  } catch (error) {
    console.error("Error refreshing permissions:", error);
    return false;
  }
};
